
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import { DashboardYearlyProps } from 'types/props-obj/dashboardYearlyProps';




const initialState: DashboardYearlyProps = {
    apiEndPoint: "year_sums",
    
    data: [],
  
};

const yearSums = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
       
       

        // GET Items
        setItemsSuccess(state, action) {
            state.data = action.payload;
            
        },

        // ADD Item
      


        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
       
    }
});


export default yearSums.reducer;

function getApiEndPoint(){
    return store.getState().yearSums.apiEndPoint
}

export const { setApiEndPoint } = yearSums.actions;
export function getyearSumsData(params:any={}) {
    return async () => {
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(yearSums.actions.setItemsSuccess(response.data));
        } catch (error) {
            // dispatch(yearSums.actions.hasError(error));
        }
    };
}

